export const EsDefaultProps = {
  'form-export-action': undefined,
  'form-more-action': undefined,
  'form-sort-action': undefined,
  'form-reset-action': undefined,
  'form-upload-action': undefined,
  'query-param': {},
  'addition-params': {},
  'table-api': {
    'url': '',
    'type': 'get',
    'query': {},
    'headers': null,
    'pageKey': {
      'current': 'current',
      'size': 'size',
    },
    'dataPath': '',
    'totalPath': ''
  },
  'inline-over-tool-hidden': false,      /*表单行间样式下超过固定栏数默认隐藏*/
  'inline-control-count': 4,
  'upload-api': {},
  'export-api': {},
  'prepare-handle-param': undefined,    /*预处理接口请求参数*/
  'prepare-handle-source': undefined,    /*预处理接口返回数据*/
  'handle-load-page': false,            /*是否手动加载列表数据*/
  'handle-reset-page': undefined,        /*手动处理重置查询参数*/
  'handle-query-param': undefined,
};

export function mergeEsProps(name, props) {
  return Object.assign({}, EsDefaultProps[name], props)
}